export default __webpack_public_path__ + "static/craig-beaur-profile-6cfdddbc8403f102a7492736e7508927.png";